import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type PublishArticleMutationVariables = Types.Exact<{
  input: Types.PublishArticleInput;
}>;


export type PublishArticleMutation = { publishArticle: { success?: boolean | null, article?: { id: string } | null } };


export const PublishArticleDocument = /*#__PURE__*/ gql`
    mutation publishArticle($input: PublishArticleInput!) {
  publishArticle(data: $input) {
    success
    article {
      id
    }
  }
}
    `;

export function usePublishArticleMutation() {
  return Urql.useMutation<PublishArticleMutation, PublishArticleMutationVariables>(PublishArticleDocument);
};